export default "__VITE_ASSET__CZERE8Wd__";